// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Other/UCP/UCP.css */

.ucp-popup-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 14px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  z-index: 9999;
  transition: all 0.3s ease;
}

.ucp-popup-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 8px rgba(0, 45, 93, 0.3);
}

.ucp-popup-container {
  position: fixed;
  width: min(400px, calc(100vw - 40px));
  height: min(500px, calc(100vh - 40px));
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  z-index: 10000; 
  will-change: transform;
  transition: opacity 0.3s ease;
  opacity: 1;
  -webkit-user-select: none;
          user-select: none;
  /* Initial position */
  left: 20px;
  bottom: 100px;
}

.ucp-popup-container.ucp-hidden {
  display: none;
}

.ucp-popup-header {
  position: absolute;
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 5px;
  cursor: move;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  -webkit-user-select: none;
          user-select: none;
  top: 0;
}

.ucp-minimize-btn {
  background-color: #EF6F53;
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  padding: 0;
  transition: all 0.2s ease;
  margin: 3px;
}

.ucp-minimize-btn:hover {
  background-color: #ff4757;
  transform: scale(1.1);
}

.ucp-iframe {
  width: 100%;
  height: calc(100% - 28px);
  border: none;
  margin-top: 28px;
  background: white;
  display: block;
}

@media (max-width: 640px) {
  .ucp-popup-container {
    width: calc(100vw - 16px);
    height: calc(100vh - 16px);
    border-radius: 8px;
  }
}

.ucp-hidden {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
}

/* Modern scrollbar for iframe content */
.ucp-iframe::-webkit-scrollbar {
  width: 10px;
}

.ucp-iframe::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ucp-iframe::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.ucp-iframe::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Other/UCP/UCP.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,6BAA6B;EAC7B,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,yBAAiB;UAAjB,iBAAiB;EACjB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* src/components/routes/Other/UCP/UCP.css */\n\n.ucp-popup-btn {\n  position: fixed;\n  bottom: 20px;\n  left: 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 50px;\n  cursor: pointer;\n  font-size: 14px;\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n  transition: all 0.3s ease;\n}\n\n.ucp-popup-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 8px rgba(0, 45, 93, 0.3);\n}\n\n.ucp-popup-container {\n  position: fixed;\n  width: min(400px, calc(100vw - 40px));\n  height: min(500px, calc(100vh - 40px));\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  z-index: 10000; \n  will-change: transform;\n  transition: opacity 0.3s ease;\n  opacity: 1;\n  user-select: none;\n  /* Initial position */\n  left: 20px;\n  bottom: 100px;\n}\n\n.ucp-popup-container.ucp-hidden {\n  display: none;\n}\n\n.ucp-popup-header {\n  position: absolute;\n  width: 100%;\n  height: 28px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 5px;\n  cursor: move;\n  background-color: #f5f5f5;\n  border-bottom: 1px solid #ddd;\n  user-select: none;\n  top: 0;\n}\n\n.ucp-minimize-btn {\n  background-color: #EF6F53;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 14px;\n  padding: 0;\n  transition: all 0.2s ease;\n  margin: 3px;\n}\n\n.ucp-minimize-btn:hover {\n  background-color: #ff4757;\n  transform: scale(1.1);\n}\n\n.ucp-iframe {\n  width: 100%;\n  height: calc(100% - 28px);\n  border: none;\n  margin-top: 28px;\n  background: white;\n  display: block;\n}\n\n@media (max-width: 640px) {\n  .ucp-popup-container {\n    width: calc(100vw - 16px);\n    height: calc(100vh - 16px);\n    border-radius: 8px;\n  }\n}\n\n.ucp-hidden {\n  visibility: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* Modern scrollbar for iframe content */\n.ucp-iframe::-webkit-scrollbar {\n  width: 10px;\n}\n\n.ucp-iframe::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.ucp-iframe::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.ucp-iframe::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
